import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

// eslint-disable-next-line
const DeleteSurveyApiService = async (request: number): Promise<any> => {
  const url = `/forms/${request}/`;
  const { data } = await axios.delete(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDeleteSurveyApiService = () =>
  // eslint-disable-next-line
  useMutation<any, AxiosError, any>(
    DeleteSurveyApiService, {
      mutationKey: ["DeleteSurveyApiService"]
    }
  );
export default useDeleteSurveyApiService;